











import AppHeader from "@/components/analytics/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppNotificationContainer from "@/components/AppNotificationContainer.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";

@Component({
  components: {
    AppHeader,
    AppFooter,
    AppNotificationContainer,
  },
})
export default class App extends Vue {
  created() {
    // Set IDs when created, handles case when user visits a url directly
    // and doesn't navigation to it from another page in the app.
    // In the direct case, there is no route change.
    // This will only fire once when the app is loaded, and will not
    // fire at the same time as onRouteUpdate
    this.$store.dispatch("setActiveCacheID", this.$route.params.cacheId ? parseInt(this.$route.params.cacheId) : 0);
    this.$store.dispatch("setActivePrefixID", this.$route.params.prefixId ? parseInt(this.$route.params.prefixId) : 0);
  }

  // route param changes are not reactive, so watch for them
  // watch route params in a single place and save values in
  // the vuex store so they are reactive.
  @Watch("$route")
  onRouteUpdate(to: Route) {
    this.$store.dispatch("setActiveCacheID", to.params.cacheId ? parseInt(to.params.cacheId) : 0);
    this.$store.dispatch("setActivePrefixID", to.params.prefixId ? parseInt(to.params.prefixId) : 0);
  }
}
